import React, { createContext, useContext, useRef, ReactNode } from 'react';

interface AudioContextType {
  registerAndPlay: (audioElement: HTMLAudioElement) => void;
}

const AudioContext = createContext<AudioContextType | undefined>(undefined);

export const useAudioManager = (): AudioContextType => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error("useAudioManager must be used within an AudioProvider");
  }
  return context;
};

interface AudioProviderProps {
  children: ReactNode;
}

export const AudioProvider = ({ children }: AudioProviderProps) => {
  const currentAudioRef = useRef<HTMLAudioElement | null>(null);

  const registerAndPlay = (audioElement: HTMLAudioElement) => {
    if (currentAudioRef.current && currentAudioRef.current !== audioElement) {
      currentAudioRef.current.pause();
    }
    currentAudioRef.current = audioElement;
    audioElement.play();
  };

  return (
    <AudioContext.Provider value={{ registerAndPlay }}>
      {children}
    </AudioContext.Provider>
  );
};
